import React from 'react'
import {Modal, Row} from 'antd'
import FuelTokenForm from '../../../../components/Project/Resources/FuelTokens/FuelTokensForm'
import FooterButtons from '../../../../elements/Buttons/FooterButtons'

function FuelTokenModal(props) {
  const {
    visible,
    modalType,
    submitting,
    submit,
    update,
    formRef,
    onCancel,
    removing,
    remove,
  } = props
  return (
    <Modal
      visible={visible}
      title={'FuelToken'}
      onCancel={onCancel}
      destroyOnClose={true}
      footer={
        <FooterButtons
          remove={remove}
          removing={removing}
          submit={submit}
          update={update}
          submitting={submitting}
          title={'Department'}
          isNew={modalType === 'new'}
          isEdit={modalType !== 'new'}
        />
      }
      width={'75%'}>
      <Row>
        <FuelTokenForm ref={formRef} {...props} />
      </Row>
    </Modal>
  )
}

FuelTokenModal.propTypes = {}
FuelTokenModal.defaultProps = {}

export default FuelTokenModal
